//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/check_box'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/popup'
import 'devextreme/ui/scroll_view'
import 'devextreme/ui/tile_view'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { ActionStatusController } from './action-status.controller'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'

//#region Asset Imports

import './action-status.scss'
import * as TEMPLATE from './action-status.tpl.html'

//#endregion

export class ActionStatusDirective implements ng.IDirective {
    restrict = 'E'

    scope = {
        popupId: '=',
    }

    controller = ['$scope', '$q', '$element', '$timeout', 'api', 'logger', 'localDictionary', USER_SESSION_SERVICE_NAME,
        ($scope, $q: ng.IQService, $element: JQuery, $timeout: ng.ITimeoutService, api: Api, logger: LoggerService, localDictionary: LocalDictionaryFactory, userSession: UserSessionService) => {
            return new ActionStatusController($scope, $q, $element, $timeout, api, logger, localDictionary, userSession)
        }
    ]

    template = TEMPLATE
    transclude = true
}